
(function layoutModuleDefinition() {

    angular.module("ui.Layout", ['ui', 'duScroll']);

})();